<div class="modal-header">
  <h3 class="modal-title">{{ 'AIRLINE_NOTIFICATION_MODAL.TITLE' | translate }}</h3>
  <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="emitClose.emit()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body modal-card-body-height">
  <div class="alert alert-warning p-3 rounded" *ngIf="airlineNotification.message && airlineID === 'AF' || airlineID === 'KL'">
    {{airlineNotification.message}}
  </div>
  <div class="fs-14 mb-2">
    <app-date-with-popover [date]="airlineNotification.timestamp * 1000">
    </app-date-with-popover>
  </div>
  <div class="amendment-container" *ngFor="let amendment of airlineNotification.amendments">
    <div class="flex-container mb-3">
      <div class="label">{{ 'AIRLINE_NOTIFICATION_MODAL.TYPE' | translate }}</div>
      <div class="value">{{amendment.type}}</div>
    </div>
    <div class="flex-container mb-3" *ngIf="amendment.context || amendment.contextMeaning">
      <div class="label">{{ 'AIRLINE_NOTIFICATION_MODAL.CONTEXT' | translate }}</div>
      <div class="value">
        <ng-container *ngIf="amendment.contextMeaning">
          {{amendment.contextMeaning}}
        </ng-container>
        <ng-container *ngIf="!amendment.contextMeaning">
          {{amendment.context | getDisruptionDescription}}
        </ng-container>
      </div>
    </div>
    <div class="flex-container" [class.mb-3]="flightDiffsToShow?.length" *ngIf="amendment.remarks?.length">
      <div class="label">{{ 'AIRLINE_NOTIFICATION_MODAL.REMARKS' | translate }}</div>
      <div class="value">
        <ng-container *ngFor="let remark of amendment.remarks">
          <div>{{remark}}</div>
        </ng-container>
      </div>
    </div>
    <div class="flex-container" *ngIf="flightDiffsToShow?.length">
      <div class="label">{{ 'AIRLINE_NOTIFICATION_MODAL.INFO' | translate }}</div>
      <div class="value">
        <ng-container *ngFor="let diff of flightDiffsToShow; let idx = index">
          <div class="d-flex flex-column gap-5">
            <app-flight-details-diff-item
              *ngIf="diff.old"
              [flight]="diff.old"
              [diffs]="diff.diffs"
              type="old"
              [diffType]="diff.type">
            </app-flight-details-diff-item>

            <app-flight-details-diff-item
              *ngIf="diff.new"
              [flight]="diff.new"
              [diffs]="diff.diffs"
              type="new"
              [diffType]="diff.type">
            </app-flight-details-diff-item>
          </div>
        </ng-container>
      </div>
    </div>
  </div>
  <div class="d-flex mb-3" *ngIf="airlineNotification.seen">
    <div class="label">{{ 'AIRLINE_NOTIFICATION_MODAL.SEEN_BY' | translate }}</div>
    <div class="value">{{airlineNotification.seenBy}}</div>
  </div>

  <app-notification-seen-checkbox
    [checked]="airlineNotification.seen"
    (emitNotificationChange)="onNotificationChange()">
  </app-notification-seen-checkbox>

  <div class="mt-3" *ngIf="orderNotificationSeenToggleError.message">
    <error-alert-block
      [error]="orderNotificationSeenToggleError"
    ></error-alert-block>
  </div>

  <ng-content></ng-content>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-secondary" data-dismiss="modal" (click)="emitClose.emit()">
    {{ 'BUTTONS.CLOSE' | translate }}
  </button>
  <button type="button"
          class="btn btn-outline-primary"
          *ngIf="airlineNotification.actionRequired?.includes('Rebook')"
          (click)="emitButtonClick.emit('rebook')">
    {{ 'AIRLINE_NOTIFICATION_MODAL.BUTTONS.ORDER_REBOOK' | translate }}
  </button>
  <button type="button"
          class="btn btn-outline-primary"
          *ngIf="airlineNotification.actionRequired?.includes('Refund')"
          (click)="emitButtonClick.emit('refund')">
    {{ 'AIRLINE_NOTIFICATION_MODAL.BUTTONS.CANCEL_REFUND' | translate }}
  </button>
  <button type="button"
          class="btn btn-primary"
          *ngIf="airlineNotification.actionRequired?.includes('AcceptChange')"
          (click)="emitButtonClick.emit('acceptChange')">
    {{ 'AIRLINE_NOTIFICATION_MODAL.BUTTONS.ACCEPT_CHANGES' | translate }}
  </button>
</div>
